import ProjectSettingsPage from "@/features/projects/project-settings.page";
import { IncognitoProjectSettingsPage } from "@/features/superuser/incognito/project/incognito-project-settings.page";
import { useWorkspaceAccess } from "@/features/workspaces/use-workspace-access";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

// CR-165: incognito mode gets the read-only settings view (no form, switch,
// select or delete); the member page is untouched.
function ProjectSettingsRoute() {
  const workspaceAccess = useWorkspaceAccess();
  const { project } = ProjectRoute.useRouteContext();

  if (workspaceAccess.mode === "incognito") {
    return <IncognitoProjectSettingsPage project={project} />;
  }

  return <ProjectSettingsPage />;
}

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/settings",
)({
  component: ProjectSettingsRoute,
});
